// packages block
import React from "react";
import { useSelector } from "react-redux";
import { Paper, Popper } from "@material-ui/core";
import { ClickAwayListener, Grow } from "@material-ui/core";
// common block
import { layoutMenuStyles } from "./style";
// constants, theme, utils and api block

export const ActionMenu = ({
  anchorEl,
  close,
  isEdit,
  isEditInvoice,
  isView,
  isDelete,
  handleDelete,
  handleEdit,
  handleEditInvoice,
  handleView,
  selectedItem,
  tableFor,
  actionMenuName,
  isConfirmationDeleteDialogVisible,
  setIsConfirmationDeleteDialogVisible,
  setRowSelectedId,
}) => {
  const classes = layoutMenuStyles();
  const { role } = useSelector((state) => state.user);

  const deletedActionMenu = () => {
    if (
      tableFor === "school" ||
      tableFor === "users" ||
      tableFor === "accounts" ||
      tableFor === "students"
    ) {
      if (!isConfirmationDeleteDialogVisible) {
        setIsConfirmationDeleteDialogVisible(true);
        close();
        setRowSelectedId(selectedItem.id);
      }
    } else {
      handleDelete(selectedItem.id);
      close();
    }
  };
  return (
    <Popper
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      role={undefined}
      transition
      disablePortal
      placement={"bottom-end"}
      className={classes.popper}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper className={classes.paper}>
            <ClickAwayListener onClickAway={close}>
              <div>
                {isView && tableFor !== "balance" && (
                  <div
                    role="presentation"
                    onClick={() => {
                      if (tableFor === "invoices")
                        handleView(selectedItem.studentId);
                      else handleView(selectedItem.id);
                    }}
                    className={classes.menuOption}
                  >
                    {actionMenuName[0]}
                  </div>
                )}
                {isEdit &&
                  (role === "manager" || role === "superadmin") &&
                  // tableFor !== "students" && //todo: do we remove this?
                  tableFor !== "balance" &&
                  tableFor !== "accounts" && (
                    <div
                      role="presentation"
                      onClick={() => {
                        handleEdit(selectedItem);
                        close();
                      }}
                      className={classes.menuOption}
                    >
                      {tableFor === "users" || tableFor === "school"
                        ? "Edit"
                        : actionMenuName[1]}
                    </div>
                  )}

                {isEditInvoice &&
                  tableFor !== "users" &&
                  tableFor !== "school" &&
                  tableFor !== "accounts" &&
                  tableFor !== "students" &&
                  (role === "manager" ||
                    (role === "superadmin" &&
                      tableFor !== "students" &&
                      tableFor !== "balance")) && (
                    <div
                      role="presentation"
                      onClick={() => {
                        handleEditInvoice(selectedItem);
                        close();
                      }}
                      className={classes.menuOption}
                    >
                      {actionMenuName[2]}
                    </div>
                  )}

                {isDelete &&
                  // tableFor !== "students" &&
                  tableFor !== "balance" && (
                    // tableFor !== "balance" &&
                    // role === "superadmin" &&
                    <div
                      role="presentation"
                      onClick={() => {
                        deletedActionMenu();
                      }}
                      className={classes.menuOption}
                    >
                      {actionMenuName[3]}
                    </div>
                  )}

                {/* {isEdit &&
                  tableFor === "school" &&
                  (
                    <div
                      role="presentation"
                      onClick={() => {
                        handleEdit(selectedItem);
                        close();
                      }}
                      className={classes.menuOption}
                    >
                      {actionMenuName[5]}
                    </div>
                  )} */}
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
